//      
                                              
             
           
              
              
                
               
           
               
             
            
                  

                                         
                           
                             
   

                                           
                                 
                                    
   

export const beforeInitialCapture = (
  args                          ,
)                             => ({
  type: 'BEFORE_INITIAL_CAPTURE',
  payload: args,
});

                         
                                                    
                                                           
                  
                            
                             
   

                           
               
                    
   

export const lift = (args          )             => ({
  type: 'LIFT',
  payload: args,
});

                                   
                     
                           
                            
                     
                             
   

                                     
                          
                              
   

export const initialPublish = (
  args                    ,
)                       => ({
  type: 'INITIAL_PUBLISH',
  payload: args,
});

                                           
                                 
                     
   

export const publishWhileDragging = (
  args           ,
)                             => ({
  type: 'PUBLISH_WHILE_DRAGGING',
  payload: args,
});

                                         
                              
                
   

export const collectionStarting = ()                           => ({
  type: 'COLLECTION_STARTING',
  payload: null,
});

                                         
                  
                      
  

                                            
                                  
                                     
   

export const updateDroppableScroll = (
  args                           ,
)                              => ({
  type: 'UPDATE_DROPPABLE_SCROLL',
  payload: args,
});

                                             
                  
                     
   

                                               
                                      
                                        
   

export const updateDroppableIsEnabled = (
  args                              ,
)                                 => ({
  type: 'UPDATE_DROPPABLE_IS_ENABLED',
  payload: args,
});

                                                    
                  
                            
   

                                                      
                                              
                                               
   

export const updateDroppableIsCombineEnabled = (
  args                                     ,
)                                        => ({
  type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
  payload: args,
});

                         
                   
   

                           
               
                    
   

export const move = (args          )             => ({
  type: 'MOVE',
  payload: args,
});

                                
                      
   

                                         
                                
                                  
   

export const moveByWindowScroll = (
  args                        ,
)                           => ({
  type: 'MOVE_BY_WINDOW_SCROLL',
  payload: args,
});

                                            
                      
   

                                       
                                     
                                       
   

export const updateViewportMaxScroll = (
  args                             ,
)                                => ({
  type: 'UPDATE_VIEWPORT_MAX_SCROLL',
  payload: args,
});

                             
                  
                
   

export const moveUp = ()               => ({
  type: 'MOVE_UP',
  payload: null,
});

                               
                    
                
   

export const moveDown = ()                 => ({
  type: 'MOVE_DOWN',
  payload: null,
});

                                
                     
                
   

export const moveRight = ()                  => ({
  type: 'MOVE_RIGHT',
  payload: null,
});

                               
                    
                
   

export const moveLeft = ()                 => ({
  type: 'MOVE_LEFT',
  payload: null,
});

                     
                
                
   

export const flush = ()              => ({
  type: 'FLUSH',
  payload: null,
});

                                
                           
                                
                       
   

                                 
                       
                           
  

export const animateDrop = (args                 )                    => ({
  type: 'DROP_ANIMATE',
  payload: args,
});

                                 
                           
   

                                  
                        
                            
  

export const completeDrop = (args                  )                     => ({
  type: 'DROP_COMPLETE',
  payload: args,
});

                  
                     
   

                           
               
                    
   

export const drop = (args          ) => ({
  type: 'DROP',
  payload: args,
});

export const cancel = () => drop({ reason: 'CANCEL' });

                                  
                       
                    
   

export const dropPending = (args          )                    => ({
  type: 'DROP_PENDING',
  payload: args,
});

                                            
                                  
                
   

export const dropAnimationFinished = ()                              => ({
  type: 'DROP_ANIMATION_FINISHED',
  payload: null,
});

                    
                              
              
                        
                              
                            
                               
                                  
                                         
                            
                                 
                           
                                      
              
                
                  
                   
                  
                     
              
                     
                               
                      
                



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/action-creators.js